const LOCAL_STORAGE_KEY = 'chat-ui-debug'

export function isDebugActive() {
  if (!window.localStorage) {
    return false
  }

  return Boolean(window.localStorage?.getItem(LOCAL_STORAGE_KEY))
}

export function log(...args) {
  if (!isDebugActive()) {
    return
  }

  console.debug(...args)
}
